.link, link:visited {
    color: var(--hps-light-blue);
}

.automatedSetupStep {
    min-width: 265px;
}

.noWrap {
    white-space: nowrap;
}

.formFieldContainer {
    margin: 10px 0px 0px 0px;
}

.buttonRowContainer {
    display: flex;
    justify-content: space-between;
    margin: 10px 0px 0px 0px;
}
.buttonsRightContainer {
    display: flex;
}

.buttonPadding {
    padding: 0px 10px 0px 0px;
}

.progressRow {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}

.progressInformation {
    margin-top: 40px;
    margin-bottom: 15px;
}